import { PdfChapterType, PdfThemeProperties } from "../types";

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

/**
 * 
 * @param chapterType {ChapterType}
 * @returns {Properties} `true` for hidden properties
 */
const getThemeConfigsForChapterTypes = (chapterType: PdfChapterType): RecursivePartial<PdfThemeProperties> & {
    headerVisibility?: "hide" | "show", footerVisibility?: "hide" | "show",
    firstSentenceShiftDownMultiplier?: number
} => {
    switch (chapterType) {
        case "toc":
            return { titleCard: { chapterNumber: false, title: true, subtitle: false, image: false }, footerVisibility: "hide", headerVisibility: "hide" };
        case "title":
            return { footerVisibility: "hide", headerVisibility: "hide" };
        case "blurbs":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, footerVisibility: "hide", headerVisibility: "hide" };
        case "dedication":
            return { titleCard: { chapterNumber: false, title: false, subtitle: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 1 / 3, footerVisibility: "hide", headerVisibility: "hide" };
        case "epigraph":
            return { titleCard: { chapterNumber: false, title: false, subtitle: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 1 / 3, footerVisibility: "hide", headerVisibility: "hide" };
        case "foreword":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "introduction":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "preface":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "prologue":
            return { titleCard: { chapterNumber: false, image: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "epilogue":
            return { titleCard: { chapterNumber: false, image: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "afterword":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "acknowledgments":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "about-author":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false }, firstSentenceShiftDownMultiplier: 2 / 5 };
        case "also-by":
            return { titleCard: { chapterNumber: false, image: false }, firstParagraph: { dropcap: false, uppercaseFourWords: false } };
        case "custom":
            return { titleCard: { chapterNumber: false, image: false, title: false, subtitle: false } };
        case "image":
            return {};
        case "chapter":
            return {};
        case "copyrights":
            return { firstParagraph: { indent: 0, dropcap: false, uppercaseFourWords: false }, paragraph: { indent: 0 } };

        default:
            return {};
    }
};

export { getThemeConfigsForChapterTypes };